// AWS
import { API } from "aws-amplify";

// React
import { 
    useEffect, 
    useState, 
    useReducer, 
} from 'react';

// Material UI
import { makeStyles } from '@material-ui/core/styles';
import { 
    Box,  
    Button,  
    FormControl,  
    FormGroup,  
    FormHelperText,  
    Grid, 
    InputLabel, 
    MenuItem, 
    Select, 
    TextField, 
    Typography, 
} from '@material-ui/core';
//import MuiPagination from '@material-ui/lab/Pagination';

// GraphQL
import { updateUserDatas } from '../../graphql/mutations';
import { listTraineeDatas, listUserDatas } from "../../graphql/queries";
import { onUpdateUserDatas } from '../../graphql/subscriptions';

// Self Making Files
import Header from '../../Commons/Header';
import Footer from '../../Commons/Footer';
import { AMAZON_COGNITO_USER_POOLS, BUTTON_CAPTION_SAVE, HEADER_TITLE_TRAINEE_MASTER_MANAGEMENT, INITIAL_QUERY, PROFILE_EDIT_CAPTION_APARTMENT_NAME, PROFILE_EDIT_CAPTION_BANK_ACCOUNT_NAME, PROFILE_EDIT_CAPTION_BANK_ACCOUNT_NUMBER, PROFILE_EDIT_CAPTION_BANK_BRANCH_NAME, PROFILE_EDIT_CAPTION_BANK_BRANCH_TYPE, PROFILE_EDIT_CAPTION_BANK_NAME, PROFILE_EDIT_CAPTION_BIRTH_DATE, PROFILE_EDIT_CAPTION_COURCE_NAME, PROFILE_EDIT_CAPTION_CWTV_NAME, PROFILE_EDIT_CAPTION_DEPARTMENT_NAME, PROFILE_EDIT_CAPTION_DISPLAY_NAME, PROFILE_EDIT_CAPTION_EMERGENCY_PERSON_ADDRESS, PROFILE_EDIT_CAPTION_EMERGENCY_PERSON_NAME, PROFILE_EDIT_CAPTION_EMERGENCY_PERSON_TYPE, PROFILE_EDIT_CAPTION_EMERGENCY_PHONE_NUMBER, PROFILE_EDIT_CAPTION_FIRST_NAME, PROFILE_EDIT_CAPTION_FIRST_NAME_KANA, PROFILE_EDIT_CAPTION_GRADUATE_SCHOOL_COURSE_NAME, PROFILE_EDIT_CAPTION_GRADUATE_SCHOOL_DEPARTMENT_NAME, PROFILE_EDIT_CAPTION_GRADUATE_SCHOOL_GRADUATION_YEAR, PROFILE_EDIT_CAPTION_GRADUATE_SCHOOL_NAME, PROFILE_EDIT_CAPTION_GRADUATION_YEAR, PROFILE_EDIT_CAPTION_HIGHSCHOOL_NAME, PROFILE_EDIT_CAPTION_LAST_NAME, PROFILE_EDIT_CAPTION_LAST_NAME_KANA, PROFILE_EDIT_CAPTION_PREF_NAME, PROFILE_EDIT_CAPTION_REMARKS, PROFILE_EDIT_CAPTION_STREET_ADDRESS, PROFILE_EDIT_CAPTION_UNIVERSITY_NAME, PROFILE_EDIT_CAPTION_WEEKDAY_PHONE_NUMBER, SUBSCRIPTION, TODAYS_WORDS_MANAGEMENT_HEADER_TITLE, TRAINEE_MASTER_MANAGEMENT_USER_LIST_NAME, UPDATE, USER_DATA_APARTMENT_NAME, USER_DATA_BANK_ACCOUNT_NAME, USER_DATA_BANK_ACCOUNT_NUMBER, USER_DATA_BANK_ACCOUNT_TYPE, USER_DATA_BANK_BRANCHE_NAME, USER_DATA_BANK_NAME, USER_DATA_BIRTH_DATE, USER_DATA_COURSE_NAME, USER_DATA_CWTV_NAME, USER_DATA_DEPARTMENT_NAME, USER_DATA_DISPLAY_NAME, USER_DATA_EMERGENCY_PERSON_ADDRESS, USER_DATA_EMERGENCY_PERSON_NAME, USER_DATA_EMERGENCY_PERSON_TYPE, USER_DATA_EMERGENCY_PHONE_NUMBER, USER_DATA_FIRST_NAME, USER_DATA_FIRST_NAME_KANA, USER_DATA_GRADUATE_SCHOOL_COURSE_NAME, USER_DATA_GRADUATE_SCHOOL_DEPARTMENT_NAME, USER_DATA_GRADUATE_SCHOOL_GRADUATION_YEAR, USER_DATA_GRADUATE_SCHOOL_NAME, USER_DATA_GRADUATION_YEAR, USER_DATA_HIGH_SCHOOL_NAME, USER_DATA_LAST_NAME, USER_DATA_LAST_NAME_KANA, USER_DATA_PREF_NAME, USER_DATA_STREET_ADDRESS, USER_DATA_UNIVERSITY_NAME, USER_DATA_USER_REMARKS, USER_DATA_WEEKDAY_PHONE_NUMBER, USER_ROLE } from '../../Commons/Consts';
import { 
    commonDBDataReducer, 
    userDataReducer, 
} from "../../Commons/Reducers";
import { commonStyles } from "../../Commons/CommonStyles";
import { LoadingIcon } from "../../Commons/LoadingIcon";
import SideMenu from "../../Commons/SideMenu";
import { 
    recursiveGrapheql, 
    consoleLog, 
    stringLengthForinVariableSettingValue, 
    validationHerfSizeNumber, 
    getCurrentUserData
} from "../../Commons/CommonFunctions";

const localStyles = makeStyles(theme => ({
    avater:{ 
        width: 128, 
        height: 128
    },
    formFont:{
        '& .MuiTypography-h6':{
            fontSize: "4vmin",
        },
        '& .MuiTypography-h5':{
            fontSize: "5vmin",
        },
        '& .MuiInputBase-input':{
            fontSize: "3vmin",
        },
        '& .MuiOutlinedInput-input':{
            paddingTop: "10px",
            paddingBottom: "10px",
        },
        '& .MuiSelect-select.MuiOutlinedInput-input':{
            paddingBottom: "4px",
        }
    },
    formSpan:{
        paddingTop: "5px",
        paddingBottom: "5px",
    },
    selectSpan:{
        paddingBottom: "10px",
        '& .MuiOutlinedInput-notchedOutline > legend, span':{
            maxWidth: "92px",
            width: "92px",
        },
    },
    controlSpan:{
        paddingBottom: "10px",
        '& .MuiInputBase-multiline':{
            paddingTop: "5px",
            paddingBottom: "5px",
        },
    },
    helperText:{
        paddingLeft: "3px",
        display: "flex",
        alignItems: "center",
    },
    centerContents:{
        display: "flex",
        flexDirection: "column",
        alignContent: "center",
        flexWrap: "nowrap",
        justifyContent: "center",
        alignItems: "center",
    },
    buttonHerf:{
        display: "flex",
        flexDirection: "column",
        alignContent: "center",
        flexWrap: "nowrap",
        justifyContent: "center",
        alignItems: "center",
        padding: "5px",
    },
    alertBar: {
        top: "10vh",
    },
    input: {
        display: 'none',
    },
    statusString:{
        marginLeft: "5px",
    },
    selectArea:{
        padding: "10px",
        width: "100%",
        height: "20%",
        position: "absolute",
        overflow: "noscroll",
        borderBottom: "solid #666666 2px",
    },
    detailArea:{
        padding: "10px",
        width: "100%",
        height: "79%",
        position: "absolute",
        overflow: "auto",
        top: "20%",
    },
    avaterIcon:{ 
        width: 128, 
        height: 128,
    },
}));


export default function TraineeMasterManagement(){
    const commonStyle = commonStyles();   
    const localStyle = localStyles();
    const [isLoading, setIsLoading] = useState(true);

    const [userDatas, dispatchUserDatas] = useReducer(commonDBDataReducer, []);
    const [userData, dispatchCurrentUserData] = useReducer(userDataReducer, []);
    const [traineeDatas, dispatchTraineeDatas] = useReducer(commonDBDataReducer, []);
    const [selectUserData, dispatchSelectUserData] = useReducer(commonDBDataReducer, []);
    const [updateStatus, setUpdateStatus] = useState(false);
    const [selectUserDataId, setSelectUserDataId] = useState();
    //const [page, setPage] = useState(1);

    const initTraineeMasterManagement = async () =>{
        try{
            // ユーザー情報を取得し、一番上のユーザーを表示する内容として設定 
            const currentUserData = await getCurrentUserData();
            dispatchCurrentUserData({ type: INITIAL_QUERY, userData: currentUserData });
            
            await recursiveGrapheql(listUserDatas, 'listUserDatas', { limit:100000 , nextToken: null}, dispatchUserDatas);
            await recursiveGrapheql(listTraineeDatas, 'listTraineeDatas', { limit:100000 , nextToken: null}, dispatchTraineeDatas);
            setIsLoading(false);
        } catch (e) {
            if (e.name === "AbortError") {
                // something to do when error occur
                consoleLog(userData.userRole, {ABORTERROR:e});
            }
            setIsLoading(false);
        }
    }
    
    const updateProfile = async () =>{
        var input = {};
        for(var obj in selectUserData){
            if(typeof(selectUserData[obj]) !== 'object' && obj !== 'createdAt' && obj !== 'updatedAt'){
                input[obj] = selectUserData[obj];
            }
        }
        const res = await API.graphql({
            query: updateUserDatas,
            variables: {
                input: input, 
                condition: {userId: {contains: selectUserData.userId}}
            },
        });
        return res;
    }
    
    useEffect(() => {
        // マウント時処理
        let abortCtrl = new AbortController();

        initTraineeMasterManagement();

        const updateSubsc = API.graphql({
            query:onUpdateUserDatas,
            authMode: AMAZON_COGNITO_USER_POOLS // 複数の認証モードを利用している場合は、この指定が必要
        }).subscribe({
        next: (msg) => {
            const data = msg.value.data.onCreateTodayWords;
            if(selectUserDataId === data.id){
                dispatchSelectUserData({ type: INITIAL_QUERY, data: data });
            }
        }});

        return () => {
            abortCtrl.abort();
            updateSubsc.unsubscribe();
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return(
        <Box>
            <Header title={HEADER_TITLE_TRAINEE_MASTER_MANAGEMENT}/>
            <SideMenu/>
            {isLoading ?
            <LoadingIcon/>
            :
            <Box className={commonStyle.pageContent}>
                <Box className={localStyle.selectArea}>
                    <FormControl 
                        fullWidth
                        variant="outlined" 
                    >
                        <InputLabel shrink id="outlined-grauation-year">{TRAINEE_MASTER_MANAGEMENT_USER_LIST_NAME}</InputLabel>
                        <Select
                            label={TRAINEE_MASTER_MANAGEMENT_USER_LIST_NAME}
                            labelId="outlined-grauation-year"
                            id='select-grauationyear'
                            value={selectUserData.id}
                            onChange={(event) => {
                                const data = userDatas.filter((data)=> data.userId === event.target.value).at(0);
                                dispatchSelectUserData({type: INITIAL_QUERY, data:data});
                            }}
                        >
                            {userDatas.filter((data) => data.userRole === USER_ROLE.Trainee)
                                    .sort((a,b) => a.lastNameKana < b.lastNameKana ? -1 : 1)
                                    .map((user) => {
                                        return (<MenuItem value={user.userId}>{user.lastName}{user.firstName}</MenuItem>)})}
                        </Select>
                    </FormControl>
                    <Grid className={commonStyle.marginTop}>
                        <Button 
                            variant="contained" 
                            color="primary"
                            onClick={updateProfile}
                        >
                            {BUTTON_CAPTION_SAVE}
                        </Button>
                        <span className={localStyle.statusString}>{updateStatus? '属性の変更があります。保存してください。':''}</span>
                    </Grid> 
                </Box>
                <Box className={localStyle.detailArea}>
                    <FormGroup className={localStyle.formFont}>
                        <Typography variant='h6'>基本情報</Typography>
                        <FormControl className={localStyle.formSpan} fullWidth>
                            <Grid container>
                                <Grid item xs={6}>
                                    <TextField
                                        label={PROFILE_EDIT_CAPTION_LAST_NAME}
                                        variant="outlined"
                                        fullWidth
                                        InputLabelProps={{ shrink: true }}
                                        value={selectUserData.lastName}
                                        onChange={(event) => {
                                            setUpdateStatus(true);
                                            dispatchSelectUserData({
                                                type: UPDATE, 
                                                updateName: USER_DATA_LAST_NAME, 
                                                updateValue: event.target.value,
                                            })
                                        }}
                                    >
                                    </TextField>
                                </Grid>
                                <Grid item xs={6}>
                                    <TextField
                                        label={PROFILE_EDIT_CAPTION_FIRST_NAME}
                                        variant="outlined"
                                        fullWidth
                                        InputLabelProps={{ shrink: true }}
                                        value={selectUserData.firstName}
                                        onChange={(event) => {
                                            setUpdateStatus(true);
                                            dispatchSelectUserData({
                                                type: UPDATE, 
                                                updateName: USER_DATA_FIRST_NAME, 
                                                updateValue: event.target.value,
                                            })
                                        }}
                                    >
                                    </TextField>
                                </Grid>
                            </Grid>          
                        </FormControl>
                        <FormControl className={localStyle.formSpan} fullWidth>
                            <Grid container>
                                <Grid item xs={6}>
                                    <TextField
                                        label={PROFILE_EDIT_CAPTION_LAST_NAME_KANA}
                                        variant="outlined"
                                        fullWidth
                                        InputLabelProps={{ shrink: true }}
                                        value={selectUserData.lastNameKana}
                                        onChange={(event) => {
                                            setUpdateStatus(true);
                                            dispatchSelectUserData({
                                                type: UPDATE, 
                                                updateName: USER_DATA_LAST_NAME_KANA, 
                                                updateValue: event.target.value,
                                            })
                                        }}
                                    >
                                    </TextField>
                                    <FormHelperText>
                                        全角カタカナのみ入力可能
                                    </FormHelperText>
                                </Grid>
                                <Grid item xs={6}>
                                    <TextField
                                        label={PROFILE_EDIT_CAPTION_FIRST_NAME_KANA}
                                        variant="outlined"
                                        fullWidth
                                        InputLabelProps={{ shrink: true }}
                                        value={selectUserData.firstNameKana}
                                        onChange={(event) => {
                                            setUpdateStatus(true);
                                            dispatchSelectUserData({
                                                type: UPDATE, 
                                                updateName: USER_DATA_FIRST_NAME_KANA, 
                                                updateValue: event.target.value,
                                            })
                                        }}
                                    >
                                    </TextField>
                                    <FormHelperText>
                                        全角カタカナのみ入力可能
                                    </FormHelperText>
                                </Grid>
                            </Grid>
                        </FormControl>
                        {/* <FormControl className={localStyle.formSpan} fullWidth>
                            <Grid container>
                                <Grid item xs={12}>
                                    <TextField
                                        label={PROFILE_EDIT_CAPTION_DISPLAY_NAME}
                                        variant="outlined"
                                        fullWidth
                                        InputLabelProps={{ shrink: true }}
                                        value={selectUserData.displayName}
                                        onChange={(event) => {
                                            setUpdateStatus(true);
                                            dispatchSelectUserData({
                                                type: UPDATE, 
                                                updateName: USER_DATA_DISPLAY_NAME, 
                                                updateValue: event.target.value,
                                            })
                                        }}
                                    >
                                    </TextField>
                                </Grid>
                            </Grid>
                        </FormControl>
                        <FormControl className={localStyle.formSpan} fullWidth>
                            <Grid container>
                                <Grid item xs={6}>
                                    <TextField
                                        id="datetime-local"
                                        label={PROFILE_EDIT_CAPTION_BIRTH_DATE}
                                        variant="outlined"
                                        fullWidth
                                        type="date"
                                        className={localStyle.textField}
                                        InputLabelProps={{ shrink: true }}
                                        value={selectUserData.birthDate}
                                        onChange={(event) => {
                                            setUpdateStatus(true);
                                            dispatchSelectUserData({
                                                type: UPDATE, 
                                                updateName: USER_DATA_BIRTH_DATE, 
                                                updateValue: event.target.value,
                                            })
                                        }}
                                    >
                                    </TextField>
                                </Grid>
                            </Grid>
                        </FormControl>
                        <FormControl className={localStyle.formSpan} fullWidth>
                            <Grid container>
                                <Grid item xs={12}>
                                    <TextField
                                        label={PROFILE_EDIT_CAPTION_WEEKDAY_PHONE_NUMBER}
                                        variant="outlined"
                                        fullWidth
                                        InputLabelProps={{ shrink: true }}
                                        value={selectUserData.weekdayPhoneNumber}
                                        onChange={(event) => {
                                            setUpdateStatus(true);
                                            dispatchSelectUserData({
                                                type: UPDATE, 
                                                updateName: USER_DATA_WEEKDAY_PHONE_NUMBER, 
                                                updateValue: stringLengthForinVariableSettingValue(validationHerfSizeNumber(event.target.value),11),
                                            })
                                        }}
                                    >
                                    </TextField>
                                    <FormHelperText>
                                        ハイフンなしの半角数字で入力をしてください。
                                    </FormHelperText>
                                </Grid>
                            </Grid>
                        </FormControl>
                        <Typography variant='h6'>住所情報</Typography>
                        <FormControl className={localStyle.formSpan} fullWidth>
                            <TextField
                                label={PROFILE_EDIT_CAPTION_PREF_NAME}
                                variant="outlined"
                                className={localStyle.controlSpan}
                                InputLabelProps={{ shrink: true }}
                                value={selectUserData.prefName}
                                onChange={(event) => {
                                    setUpdateStatus(true);
                                    dispatchSelectUserData({
                                        type: UPDATE, 
                                        updateName: USER_DATA_PREF_NAME, 
                                        updateValue: event.target.value,
                                    })
                                }}
                            >
                            </TextField>
                            <TextField
                                label={PROFILE_EDIT_CAPTION_CWTV_NAME}
                                variant="outlined"
                                className={localStyle.controlSpan}
                                InputLabelProps={{ shrink: true }}
                                value={selectUserData.cwtvName}
                                onChange={(event) => {
                                    setUpdateStatus(true);
                                    dispatchSelectUserData({
                                        type: UPDATE, 
                                        updateName: USER_DATA_CWTV_NAME, 
                                        updateValue: event.target.value,
                                    })
                                }}
                            >
                            </TextField>
                            <TextField
                                label={PROFILE_EDIT_CAPTION_STREET_ADDRESS}
                                variant="outlined"
                                className={localStyle.controlSpan}
                                InputLabelProps={{ shrink: true }}
                                value={selectUserData.streetAddress}
                                onChange={(event) => {
                                    setUpdateStatus(true);
                                    dispatchSelectUserData({
                                        type: UPDATE, 
                                        updateName: USER_DATA_STREET_ADDRESS, 
                                        updateValue: event.target.value,
                                    })
                                }}
                            >
                            </TextField>
                            <TextField
                                label={PROFILE_EDIT_CAPTION_APARTMENT_NAME}
                                variant="outlined"
                                className={localStyle.controlSpan}
                                InputLabelProps={{ shrink: true }}
                                value={selectUserData.apartmentName}
                                onChange={(event) => {
                                    setUpdateStatus(true);
                                    dispatchSelectUserData({
                                        type: UPDATE, 
                                        updateName: USER_DATA_APARTMENT_NAME, 
                                        updateValue: event.target.value,
                                    })
                                }}
                            >
                            </TextField>
                        </FormControl> */}
                        <Typography variant='h6'>学校情報</Typography>
                        <FormControl className={localStyle.formSpan} fullWidth>
                            <TextField
                                label={PROFILE_EDIT_CAPTION_HIGHSCHOOL_NAME}
                                variant="outlined"
                                fullWidth
                                className={localStyle.controlSpan}
                                InputLabelProps={{ shrink: true }}
                                value={selectUserData.highSchoolName}
                                onChange={(event) => {
                                    setUpdateStatus(true);
                                    dispatchSelectUserData({
                                        type: UPDATE, 
                                        updateName: USER_DATA_HIGH_SCHOOL_NAME, 
                                        updateValue: event.target.value,
                                    })
                                }}
                            >
                            </TextField>
                            <TextField
                                label={PROFILE_EDIT_CAPTION_UNIVERSITY_NAME}
                                variant="outlined"
                                fullWidth
                                className={localStyle.controlSpan}
                                InputLabelProps={{ shrink: true }}
                                value={selectUserData.universityName}
                                onChange={(event) => {
                                    setUpdateStatus(true);
                                    dispatchSelectUserData({
                                        type: UPDATE, 
                                        updateName: USER_DATA_UNIVERSITY_NAME, 
                                        updateValue: event.target.value,
                                    })
                                }}
                            >
                            </TextField>
                            <TextField
                                label={PROFILE_EDIT_CAPTION_DEPARTMENT_NAME}
                                variant="outlined"
                                fullWidth
                                className={localStyle.controlSpan}
                                InputLabelProps={{ shrink: true }}
                                value={selectUserData.departmentName}
                                onChange={(event) => {
                                    setUpdateStatus(true);
                                    dispatchSelectUserData({
                                        type: UPDATE, 
                                        updateName: USER_DATA_DEPARTMENT_NAME, 
                                        updateValue: event.target.value,
                                    })
                                }}
                            >
                            </TextField>
                            <TextField
                                label={PROFILE_EDIT_CAPTION_COURCE_NAME}
                                variant="outlined"
                                fullWidth
                                className={localStyle.controlSpan}
                                InputLabelProps={{ shrink: true }}
                                value={selectUserData.courseName}
                                onChange={(event) => {
                                    setUpdateStatus(true);
                                    dispatchSelectUserData({
                                        type: UPDATE, 
                                        updateName: USER_DATA_COURSE_NAME, 
                                        updateValue: event.target.value,
                                    })
                                }}
                            >
                            </TextField>
                            <Grid container className={localStyle.selectSpan}>
                                <Grid item xs={6}>
                                    <FormControl 
                                        fullWidth
                                        variant="outlined" 
                                    >
                                        <InputLabel shrink id="outlined-grauation-year">{PROFILE_EDIT_CAPTION_GRADUATION_YEAR}</InputLabel>
                                        <Select
                                            label={PROFILE_EDIT_CAPTION_GRADUATION_YEAR}
                                            labelId="outlined-grauation-year"
                                            id='select-grauationyear'
                                            value={selectUserData.graduationYear}
                                            onChange={(event) => {
                                                setUpdateStatus(true);
                                                dispatchSelectUserData({
                                                    type: UPDATE, 
                                                    updateName: USER_DATA_GRADUATION_YEAR, 
                                                    updateValue: event.target.value,
                                                })
                                            }}
                                        >
                                            <MenuItem value={null}></MenuItem>
                                            <MenuItem value={'2030-03-01'}>30卒</MenuItem>
                                            <MenuItem value={'2029-03-01'}>29卒</MenuItem>
                                            <MenuItem value={'2028-03-01'}>28卒</MenuItem>
                                            <MenuItem value={'2027-03-01'}>27卒</MenuItem>
                                            <MenuItem value={'2026-03-01'}>26卒</MenuItem>
                                            <MenuItem value={'2025-03-01'}>25卒</MenuItem>
                                            <MenuItem value={'2024-03-01'}>24卒</MenuItem>
                                            <MenuItem value={'2023-03-01'}>23卒</MenuItem>
                                            <MenuItem value={'2022-03-01'}>22卒</MenuItem>
                                            <MenuItem value={'2021-03-01'}>21卒</MenuItem>
                                            <MenuItem value={'2020-03-01'}>20卒</MenuItem>
                                            <MenuItem value={'2019-03-01'}>19卒</MenuItem>
                                            <MenuItem value={'2018-03-01'}>18卒</MenuItem>
                                            <MenuItem value={'2017-03-01'}>17卒</MenuItem>
                                            <MenuItem value={'2016-03-01'}>16卒</MenuItem>
                                            <MenuItem value={'2015-03-01'}>15卒</MenuItem>
                                            <MenuItem value={'2014-03-01'}>14卒</MenuItem>
                                            <MenuItem value={'2013-03-01'}>13卒</MenuItem>
                                            <MenuItem value={'2012-03-01'}>12卒</MenuItem>
                                            <MenuItem value={'2011-03-01'}>11卒</MenuItem>
                                            <MenuItem value={'2010-03-01'}>10卒</MenuItem>
                                            <MenuItem value={'2009-03-01'}>09卒</MenuItem>
                                            <MenuItem value={'2008-03-01'}>08卒</MenuItem>
                                            <MenuItem value={'2007-03-01'}>07卒</MenuItem>
                                            <MenuItem value={'2006-03-01'}>06卒</MenuItem>
                                            <MenuItem value={'2005-03-01'}>05卒</MenuItem>
                                            <MenuItem value={'2004-03-01'}>04卒</MenuItem>
                                            <MenuItem value={'2003-03-01'}>03卒</MenuItem>
                                            <MenuItem value={'2002-03-01'}>02卒</MenuItem>
                                            <MenuItem value={'2001-03-01'}>01卒</MenuItem>
                                        </Select>
                                    </FormControl>
                                </Grid>
                            </Grid>
                            <TextField
                                label={PROFILE_EDIT_CAPTION_GRADUATE_SCHOOL_NAME}
                                variant="outlined"
                                fullWidth
                                className={localStyle.controlSpan}
                                InputLabelProps={{ shrink: true }}
                                value={selectUserData.graduateSchoolName}
                                onChange={(event) => {
                                    setUpdateStatus(true);
                                    dispatchSelectUserData({
                                        type: UPDATE, 
                                        updateName: USER_DATA_GRADUATE_SCHOOL_NAME, 
                                        updateValue: event.target.value,
                                    })
                                }}
                            >
                            </TextField>
                            <TextField
                                label={PROFILE_EDIT_CAPTION_GRADUATE_SCHOOL_DEPARTMENT_NAME}
                                variant="outlined"
                                fullWidth
                                className={localStyle.controlSpan}
                                InputLabelProps={{ shrink: true }}
                                value={selectUserData.graduateSchoolDepartmentName}
                                onChange={(event) => {
                                    setUpdateStatus(true);
                                    dispatchSelectUserData({
                                        type: UPDATE, 
                                        updateName: USER_DATA_GRADUATE_SCHOOL_DEPARTMENT_NAME, 
                                        updateValue: event.target.value,
                                    })
                                }}
                            >
                            </TextField>
                            <TextField
                                label={PROFILE_EDIT_CAPTION_GRADUATE_SCHOOL_COURSE_NAME}
                                variant="outlined"
                                fullWidth
                                className={localStyle.controlSpan}
                                InputLabelProps={{ shrink: true }}
                                value={selectUserData.graduateSchoolCourseName}
                                onChange={(event) => {
                                    setUpdateStatus(true);
                                    dispatchSelectUserData({
                                        type: UPDATE, 
                                        updateName: USER_DATA_GRADUATE_SCHOOL_COURSE_NAME, 
                                        updateValue: event.target.value,
                                    })
                                }}
                            >
                            </TextField>
                            <Grid container className={localStyle.selectSpan}>
                                <Grid item xs={6}>
                                    <FormControl 
                                        fullWidth
                                        variant="outlined" 
                                    >
                                        <InputLabel shrink id="outlined-graduate-school-graduation-year">{PROFILE_EDIT_CAPTION_GRADUATE_SCHOOL_GRADUATION_YEAR}</InputLabel>
                                        <Select
                                            label={PROFILE_EDIT_CAPTION_GRADUATE_SCHOOL_GRADUATION_YEAR}
                                            labelId="outlined-graduate-school-graduation-year"
                                            id="select-graduate-school-graduation-year"
                                            InputLabelProps={{ shrink: true }}
                                            value={selectUserData.graduateSchoolGraduationYear}
                                            onChange={(event) => {
                                                setUpdateStatus(true);
                                                dispatchSelectUserData({
                                                    type: UPDATE, 
                                                    updateName: USER_DATA_GRADUATE_SCHOOL_GRADUATION_YEAR, 
                                                    updateValue: event.target.value,
                                                })
                                            }}
                                        >
                                            <MenuItem value={null}></MenuItem>
                                            <MenuItem value={'2030-03-01'}>30卒</MenuItem>
                                            <MenuItem value={'2029-03-01'}>29卒</MenuItem>
                                            <MenuItem value={'2028-03-01'}>28卒</MenuItem>
                                            <MenuItem value={'2027-03-01'}>27卒</MenuItem>
                                            <MenuItem value={'2026-03-01'}>26卒</MenuItem>
                                            <MenuItem value={'2025-03-01'}>25卒</MenuItem>
                                            <MenuItem value={'2024-03-01'}>24卒</MenuItem>
                                            <MenuItem value={'2023-03-01'}>23卒</MenuItem>
                                            <MenuItem value={'2022-03-01'}>22卒</MenuItem>
                                            <MenuItem value={'2021-03-01'}>21卒</MenuItem>
                                            <MenuItem value={'2020-03-01'}>20卒</MenuItem>
                                            <MenuItem value={'2019-03-01'}>19卒</MenuItem>
                                            <MenuItem value={'2018-03-01'}>18卒</MenuItem>
                                            <MenuItem value={'2017-03-01'}>17卒</MenuItem>
                                            <MenuItem value={'2016-03-01'}>16卒</MenuItem>
                                            <MenuItem value={'2015-03-01'}>15卒</MenuItem>
                                            <MenuItem value={'2014-03-01'}>14卒</MenuItem>
                                            <MenuItem value={'2013-03-01'}>13卒</MenuItem>
                                            <MenuItem value={'2012-03-01'}>12卒</MenuItem>
                                            <MenuItem value={'2011-03-01'}>11卒</MenuItem>
                                            <MenuItem value={'2010-03-01'}>10卒</MenuItem>
                                            <MenuItem value={'2009-03-01'}>09卒</MenuItem>
                                            <MenuItem value={'2008-03-01'}>08卒</MenuItem>
                                            <MenuItem value={'2007-03-01'}>07卒</MenuItem>
                                            <MenuItem value={'2006-03-01'}>06卒</MenuItem>
                                            <MenuItem value={'2005-03-01'}>05卒</MenuItem>
                                            <MenuItem value={'2004-03-01'}>04卒</MenuItem>
                                            <MenuItem value={'2003-03-01'}>03卒</MenuItem>
                                            <MenuItem value={'2002-03-01'}>02卒</MenuItem>
                                            <MenuItem value={'2001-03-01'}>01卒</MenuItem>
                                        </Select>
                                    </FormControl>
                                </Grid>
                            </Grid>
                        </FormControl>
                        {/* <Typography variant='h6'>緊急連絡先情報</Typography>
                        <FormControl className={localStyle.formSpan} fullWidth>
                            <Grid container>
                                <Grid item xs={12}>
                                    <TextField
                                        label={PROFILE_EDIT_CAPTION_EMERGENCY_PHONE_NUMBER}
                                        variant="outlined"
                                        fullWidth
                                        InputLabelProps={{ shrink: true }}
                                        value={selectUserData.emergencyPhoneNumber}
                                        onChange={(event) => {
                                            setUpdateStatus(true);
                                            dispatchSelectUserData({
                                                type: UPDATE, 
                                                updateName: USER_DATA_EMERGENCY_PHONE_NUMBER, 
                                                updateValue: stringLengthForinVariableSettingValue(validationHerfSizeNumber(event.target.value),11),
                                            })
                                        }}
                                    >
                                    </TextField>
                                    <FormHelperText className={localStyle.helperText}>
                                        ハイフンなしの半角数字で入力をしてください。
                                    </FormHelperText>
                                </Grid>
                            </Grid>    
                        </FormControl>
                        <FormControl className={localStyle.formSpan} fullWidth>
                            <Grid container>
                                <Grid item xs={6}>
                                    <TextField
                                        label={PROFILE_EDIT_CAPTION_EMERGENCY_PERSON_NAME}
                                        variant="outlined"
                                        fullWidth
                                        InputLabelProps={{ shrink: true }}
                                        value={selectUserData.emergencyPersonName}
                                        onChange={(event) => {
                                            setUpdateStatus(true);
                                            dispatchSelectUserData({
                                                type: UPDATE, 
                                                updateName: USER_DATA_EMERGENCY_PERSON_NAME, 
                                                updateValue: event.target.value,
                                            })
                                        }}
                                    >
                                    </TextField>
                                </Grid>
                                <Grid item xs={6}>
                                    <TextField
                                        label={PROFILE_EDIT_CAPTION_EMERGENCY_PERSON_TYPE}
                                        variant="outlined"
                                        fullWidth
                                        InputLabelProps={{ shrink: true }}
                                        value={selectUserData.emergencyPersonType}
                                        onChange={(event) => {
                                            setUpdateStatus(true);
                                            dispatchSelectUserData({
                                                type: UPDATE, 
                                                updateName: USER_DATA_EMERGENCY_PERSON_TYPE, 
                                                updateValue: event.target.value,
                                            })
                                        }}
                                    >
                                    </TextField>
                                </Grid>
                            </Grid>
                        </FormControl>
                        <FormControl className={localStyle.formSpan} fullWidth>
                            <Grid container>
                                <Grid item xs={12}>
                                    <TextField
                                        label={PROFILE_EDIT_CAPTION_EMERGENCY_PERSON_ADDRESS}
                                        variant="outlined"
                                        fullWidth
                                        InputLabelProps={{ shrink: true }}
                                        value={selectUserData.emergencyPersonAddress}
                                        onChange={(event) => {
                                            setUpdateStatus(true);
                                            dispatchSelectUserData({
                                                type: UPDATE, 
                                                updateName: USER_DATA_EMERGENCY_PERSON_ADDRESS, 
                                                updateValue: event.target.value,
                                            })
                                        }}
                                    >
                                    </TextField>
                                </Grid>
                            </Grid>
                        </FormControl>
                        <Typography variant='h6'>口座情報</Typography>
                        <FormControl className={localStyle.formSpan} fullWidth>
                            <TextField
                                label={PROFILE_EDIT_CAPTION_BANK_NAME}
                                variant="outlined"
                                className={localStyle.controlSpan}
                                InputLabelProps={{ shrink: true }}
                                value={selectUserData.bankName}
                                onChange={(event) => {
                                    setUpdateStatus(true);
                                    dispatchSelectUserData({
                                        type: UPDATE, 
                                        updateName: USER_DATA_BANK_NAME, 
                                        updateValue: event.target.value,
                                    })
                                }}
                            >
                            </TextField>
                            <TextField
                                label={PROFILE_EDIT_CAPTION_BANK_BRANCH_NAME}
                                variant="outlined"
                                className={localStyle.controlSpan}
                                InputLabelProps={{ shrink: true }}
                                value={selectUserData.bankBrancheName}
                                onChange={(event) => {
                                    setUpdateStatus(true);
                                    dispatchSelectUserData({
                                        type: UPDATE, 
                                        updateName: USER_DATA_BANK_BRANCHE_NAME, 
                                        updateValue: event.target.value,
                                    })
                                }}
                            >
                            </TextField>
                            <Grid container>
                                <Grid item xs={4}>
                                    <FormControl fullWidth
                                            variant="outlined" className={localStyle.formControl}>
                                        <InputLabel id="outlined-bank-account-type">{PROFILE_EDIT_CAPTION_BANK_BRANCH_TYPE}</InputLabel>
                                        <Select
                                            label={PROFILE_EDIT_CAPTION_BANK_BRANCH_TYPE}
                                            labelId="outlined-bank-account-type"
                                            id='select-bank-account-type'
                                            InputLabelProps={{ shrink: true }}
                                            value={selectUserData.bankAcCcountType}
                                            defaultValue={1}
                                            onChange={(event) => {
                                                setUpdateStatus(true);
                                                dispatchSelectUserData({
                                                    type: UPDATE, 
                                                    updateName: USER_DATA_BANK_ACCOUNT_TYPE, 
                                                    updateValue: event.target.value,
                                                })
                                            }}
                                        >
                                            <MenuItem value={1}>普通</MenuItem>
                                            <MenuItem value={2}>当座</MenuItem>
                                            <MenuItem value={3}>その他</MenuItem>
                                        </Select>
                                    </FormControl>
                                </Grid>
                                <Grid item xs={8}>
                                    <TextField
                                        label={PROFILE_EDIT_CAPTION_BANK_ACCOUNT_NUMBER}
                                        variant="outlined"
                                        fullWidth
                                        InputLabelProps={{ shrink: true }}
                                        value={selectUserData.bankAccountNumber}
                                        onChange={(event) => {
                                            setUpdateStatus(true);
                                            dispatchSelectUserData({
                                                type: UPDATE, 
                                                updateName: USER_DATA_BANK_ACCOUNT_NUMBER, 
                                                updateValue: stringLengthForinVariableSettingValue(validationHerfSizeNumber(event.target.value),8),
                                            })
                                        }}
                                    >
                                    </TextField>
                                    <FormHelperText>
                                        半角数字のみ入力可能
                                    </FormHelperText>
                                </Grid>
                            </Grid>
                        </FormControl>
                        <FormControl className={localStyle.formSpan} fullWidth>
                            <Grid container>
                                <Grid item xs={12}>
                                    <TextField
                                        label={PROFILE_EDIT_CAPTION_BANK_ACCOUNT_NAME}
                                        variant="outlined"
                                        fullWidth
                                        InputLabelProps={{ shrink: true }}
                                        value={selectUserData.bankAccountName}
                                        onChange={(event) => {
                                            setUpdateStatus(true);
                                            dispatchSelectUserData({
                                                type: UPDATE, 
                                                updateName: USER_DATA_BANK_ACCOUNT_NAME, 
                                                updateValue: event.target.value,
                                            })
                                        }}
                                    >
                                    </TextField>
                                    <FormHelperText>
                                        全角カタカナと空白のみ入力可能
                                    </FormHelperText>
                                </Grid>
                            </Grid>
                        </FormControl>
                        <FormControl className={localStyle.formSpan} fullWidth>
                            <Grid container>
                                <Grid item xs={12}>
                                <TextField
                                    label={PROFILE_EDIT_CAPTION_REMARKS}
                                    variant="outlined"
                                    fullWidth
                                    multiline
                                    minRows={1}
                                    maxRows={8}
                                    className={localStyle.controlSpan}
                                    InputLabelProps={{ shrink: true }}
                                    value={selectUserData.userRemarks}
                                    onChange={(event) => (
                                        dispatchSelectUserData({
                                            type: UPDATE, 
                                            updateName: USER_DATA_USER_REMARKS, 
                                            updateValue: event.target.value,
                                        })
                                    )}
                                >
                                </TextField>
                                </Grid>
                            </Grid>
                        </FormControl> */}
                    </FormGroup>
                    <Box mt={3}>
                        {userDatas
                        .map(data => {
                            return (
                            <Grid container spacing={0}>
                                <Grid item xs={12} className={localStyle.messegeTextarea}>
                                    {data.lastName}{data.firstName}
                                </Grid>
                            </Grid>)
                        })}
                    </Box>
                    <Box className={commonStyle.endBox}/>
                </Box>
            </Box>
            }
            <Footer/>
        </Box>
    );
}
